import { createRoutine } from 'redux-saga-routines';
import { action, ActionType } from 'typesafe-actions';

export const routine = createRoutine('FULL_REGISTRATION/LOGIN_AND_PASSWORD');

export const SAVE = 'FULL_REGISTRATION/LOGIN_AND_PASSWORD/SAVE';

export const actions = {
  save: (login: string, password: string) => action(SAVE, { login, password }),
};

export type Action = ActionType<typeof actions>;
